import React from 'react';
import classnames from 'classnames';
import Modal from './modals/modal.component';

type WarningDialogProps = {
  onCancel: () => void,
  onConfirm: () => void,
  message: string | React.ReactNode,
  title: string,
  dismissText: string,
  submitText: string,
  className: string,
  isVisible: boolean,
}

const WarningDialog = ({
  onCancel,
  onConfirm,
  message,
  title,
  dismissText,
  submitText,
  className,
  isVisible,
}: WarningDialogProps) => (
  <Modal
    className={classnames('confirm-dialog-modal', className)}
    cancelAsPrimary
    title={title}
    closeAction={onCancel}
    dismissText={dismissText}
    dismissAction={onCancel}
    submitText={submitText}
    submitAction={onConfirm}
    isVisible={isVisible}
  >
    <div>
      {message}
    </div>
  </Modal>
);

export default WarningDialog;
